let scriptLoaded = false;
let scriptLoading = false;
const loadCallbacks: Array<() => void> = [];

export const loadTurnstileScript = () =>
    new Promise<void>((resolve) => {
        if (scriptLoaded && window.turnstile) {
            resolve();
            return;
        }

        loadCallbacks.push(resolve);
        if (scriptLoading) return;
        scriptLoading = true;

        window.onTurnstileLoad = () => {
            scriptLoaded = true;
            scriptLoading = false;
            loadCallbacks.splice(0).forEach((callback) => callback());
        };

        const script = document.createElement('script');
        script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?onload=onTurnstileLoad';
        script.async = true;
        script.defer = true;
        document.head.appendChild(script);
    });

export const prefetchTurnstileScript = () => loadTurnstileScript();
